import {
  IconBook,
  IconChartBar,
  IconChartFunnel,
  IconChartLine,
  IconClockHour4,
  IconCloudUpload,
  IconDatabase,
  IconDatabaseCog,
  IconFileText,
  IconHistory,
  IconListCheck,
  IconMailFast,
  IconTimeline,
  type TablerIcon,
} from '@tabler/icons-react';

export type AdminEntry = { id: string; label: string; href: string; icon: TablerIcon };
export type AdminGroup = { label: string; entries: AdminEntry[] };

// Only the French team uses the admin, so its labels are written in French, without i18n.
export const ADMIN_PAGE_GROUPS: AdminGroup[] = [
  {
    label: 'Indicateurs',
    entries: [
      { id: 'admin_revenue', label: 'Revenus', href: '/admin/revenue', icon: IconChartBar },
      { id: 'admin_engagements', label: 'Engagement', href: '/admin/engagements', icon: IconChartFunnel },
      { id: 'admin_stats', label: 'Stats', href: '/admin/stats', icon: IconChartLine },
    ],
  },
  {
    label: 'E-mails',
    entries: [
      { id: 'admin_email_deliveries', label: 'Délivrabilité', href: '/admin/email_deliveries', icon: IconMailFast },
      { id: 'admin_email_timings', label: 'Délais', href: '/admin/email_timings', icon: IconClockHour4 },
      {
        id: 'admin_external_services',
        label: 'Services externes',
        href: '/admin/external_services',
        icon: IconCloudUpload,
      },
    ],
  },
  {
    label: 'Intégrations',
    entries: [
      { id: 'admin_shared_data', label: 'Données partagées', href: '/admin/shared_data', icon: IconDatabaseCog },
    ],
  },
  {
    label: 'Documents',
    entries: [
      { id: 'admin_internal_docs', label: 'Documentation interne', href: '/admin/internal_docs', icon: IconBook },
      { id: 'admin_plans', label: 'Plans', href: '/admin/plans', icon: IconListCheck },
      { id: 'admin_postmortems', label: 'Post-mortems', href: '/admin/postmortems', icon: IconFileText },
    ],
  },
];

export const ADMIN_PAGES: AdminEntry[] = ADMIN_PAGE_GROUPS.flatMap((group) => group.entries);

// Rendered outside Inertia, so reaching them needs a full page load.
export const ADMIN_TOOLS_GROUP: AdminGroup = {
  label: 'Outils',
  entries: [
    { id: 'admin_avo', label: 'Avo', href: '/avo', icon: IconDatabase },
    { id: 'admin_background_jobs', label: 'Tâches de fond', href: '/jobs', icon: IconHistory },
    { id: 'admin_blazer', label: 'Blazer', href: '/blazer', icon: IconTimeline },
  ],
};
